import { getAuth, signInWithCustomToken } from 'firebase/auth';
import app from './firebaseConfig';
import { instance } from '../shared/utilites/ApiClient';

const auth = getAuth(app);

/**
 * Authenticate with Firebase using custom token from backend
 */
export const authenticateWithFirebase = async () => {
  try {
    // Check if already authenticated
    if (auth.currentUser) {
      console.log('Already authenticated with Firebase:', auth.currentUser.uid);
      return auth.currentUser;
    }

    console.log('Fetching Firebase custom token from backend...');

    // Get custom token from your backend API (uses configured axios instance with x-api-token)
    const response = await instance.get('/chat/app_access?uid=tw2t2twsgsd');

    if (response.data && response.data.token) {
      const customToken = response.data.token;
      console.log('Custom token received, signing in to Firebase...');

      // Sign in with custom token
      const userCredential = await signInWithCustomToken(auth, customToken);
      console.log('Successfully authenticated with Firebase:', userCredential.user.uid);

      return userCredential.user;
    } else {
      throw new Error('No token received from backend');
    }

  } catch (error) {
    console.error('Firebase authentication error:', error);
    throw error;
  }
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  return auth.currentUser !== null;
};

/**
 * Get current Firebase user
 */
export const getCurrentUser = () => {
  return auth.currentUser;
};

/**
 * Sign out from Firebase
 */
export const signOut = async () => {
  try {
    await auth.signOut();
    console.log('Signed out from Firebase');
  } catch (error) {
    console.error('Error signing out:', error);
  }
};

export default auth;
